import React, { useState, useEffect } from 'react';
import OffersService from '../Services/OffersService';
import SalesService from '../Services/SalesService';
import { Button, ButtonGroup, Card, Col, Input, Row } from 'reactstrap';
import { withTranslation } from 'react-multi-lang';

const CostsPerCustomer = ({t}) => {
    const [costsPerCustomer, setCostsPerCustomer] = useState([]);
    const [updatedCosts, setUpdatedCosts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [search, setSearch] = useState('');
    const [displayableCustomers, setDisplayableCustomers] = useState([]);

    const [page, setPage] = useState(1);

    const offersService = new OffersService();
    const salesService = new SalesService();

    useEffect(() => {
        salesService.getCostsPerCustomer().then(data => {
            setCostsPerCustomer(data);
        });
        offersService.getCustomers('').then(data => {
            setCustomers(data);
            setDisplayableCustomers(data.slice(0, 100));
        });
    }, []);

    useEffect(() => {
        setDisplayableCustomers(customers
            .filter(c => c.Code.includes(search) || c.Name.includes(search) || (c.TaxRegistrationNumber && c.TaxRegistrationNumber.includes(search)))
            .slice((page - 1) * 100, page * 100));
        setPage(1);
    }, [search]);

    useEffect(() => {
        setDisplayableCustomers(customers
            .filter(c => c.Code.includes(search) || c.Name.includes(search) || (c.TaxRegistrationNumber && c.TaxRegistrationNumber.includes(search)))
            .slice((page - 1) * 100, page * 100));
    }, [page])

    const updateCosts = () => {
        salesService.updateCostsPerCustomer(updatedCosts).then(data => {
            salesService.getCostsPerCustomer().then(data => {
                setCostsPerCustomer(data);
            });
            setUpdatedCosts([]);
        });
    }

    return <Row>
        <Col md="12">
            <Card>
                <div className="card-header">
                    <h5 className="title">Κόστος Μεταφορικών / Πελάτη</h5>
                </div>
                <div className="card-body">
                    <Row>
                        <Col md="9">
                            <Input placeholder={t('volumes.search')} onChange={(e) => setSearch(e.target.value)} />
                        </Col>
                        <Col md="3">
                            <Button block color="primary" onClick={() => {
                                updateCosts();
                            }}>{t('volumes.save')}</Button>
                        </Col>
                    </Row>
                    <hr />
                    <div className="table-responsive">
                        <table className="table">
                            <thead className=" text-primary">
                                <tr>
                                    <th>Πελάτης</th>
                                    <th>Κόστος μεταφορικών / Τόνο</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayableCustomers.map(customer => {
                                    return <tr key={customer.Code}>
                                        <td>{customer.Code + ' - ' + customer.TaxRegistrationNumber + ' - ' + customer.Name}</td>
                                        <td>
                                            <Input type="number" 
                                                defaultValue={costsPerCustomer.filter(cpc => cpc.customerCode === customer.Code)[0] ? costsPerCustomer.filter(cpc => cpc.customerCode === customer.Code)[0].pricePerTone : 0} 
                                                onChange={(e) => {
                                                    let updCosts = updatedCosts.filter(uc => uc.customerCode !== customer.Code);
                                                    setUpdatedCosts([...updCosts, {customerCode: customer.Code, pricePerTone: e.target.valueAsNumber}])
                                                }} />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                        <ButtonGroup>
                            <Button disabled={page === 1} onClick={() => setPage(page - 1)}>Επόμενη Σελίδα</Button>
                            <Button disabled={page * 100 >= customers.filter(c => c.Code.includes(search) || c.Name.includes(search) || (c.TaxRegistrationNumber && c.TaxRegistrationNumber.includes(search))).length} onClick={() => setPage(page + 1)}>Επόμενη Σελίδα</Button>
                        </ButtonGroup>
                    </div>
                </div>
            </Card>
        </Col>
    </Row>
}


export default withTranslation(CostsPerCustomer);